import {Box, Fade, Stack} from "@mui/material";
import React, {useRef} from "react";
import Planet from '../assets/planet.svg';
import Boxs from '../assets/box.svg';
import FeatureCard from "../components/FeatureCard";
import {SimpleItemListRow} from "../components/SimpleItemListRow";

const NoItems = React.memo(NoItemsBase);
function NoItemsBase({
                                    showHome,
                                    darkMode,
                                    loading,
                                    noUser,
                                    items,
                                    handleToggle,
                                    setSearchParams,
                                    handlePreload,
                                    preload,
                                    currentItem,
                                    recentItems,
                                    currentOverlayId,
                                    setCurrentOverlayId,
                                    currencyApi,
                                    auth
                                }) {
    const ref = useRef(null);
    return (showHome ?
                <Fade in={items === 0} unmountOnExit>
                    <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        sx={{userSelect: 'none'}}
                    >
                        <Stack direction={'column'} sx={{marginBottom: "64px", width: "100%", zIndex: 0}}>
                            <FeatureCard noUser={noUser} darkMode={darkMode} handleToggle={handleToggle} topRef={ref}>
                                <SimpleItemListRow titleRef={ref} setSearchParams={setSearchParams}
                                                   handlePreload={handlePreload}
                                                   noUser={noUser}
                                                   handleToggle={handleToggle} preload={preload}
                                                   currentItem={currentItem} recentItems={recentItems}
                                                   currentOverlayId={currentOverlayId}
                                                   setCurrentOverlayId={setCurrentOverlayId} currencyApi={currencyApi}
                                                   auth={auth}
                                                   rows={3}
                                                   title={"Omega watches"}
                                                   subtitle={"Constellations, Seamasters, Speedmasters— act quickly on these global Omega watch auctions ending soon."}
                                                   url={"keywords=omega&category=260325&sort=EndTimeSoonest&listingTypes=Auction%2CAuctionWithBIN&prefer=ca&categoryName=Watches&currency=CAD"}
                                />
                                <SimpleItemListRow setSearchParams={setSearchParams} handlePreload={handlePreload}
                                                   noUser={noUser}
                                                   handleToggle={handleToggle} preload={preload}
                                                   currentItem={currentItem} recentItems={recentItems}
                                                   currentOverlayId={currentOverlayId}
                                                   setCurrentOverlayId={setCurrentOverlayId} currencyApi={currencyApi}
                                                   auth={auth}
                                                   rows={3}
                                                   title={"Rolex watches"}
                                                   subtitle={"Grab a Sub while they're hot. Rolex auctions from around the world, ending soon."}
                                                   url={"keywords=rolex&category=260325&sort=EndTimeSoonest&listingTypes=Auction%2CAuctionWithBIN&prefer=ca&categoryName=Watches&blockedCountries=false&blockedSellers=false&currency=CAD"}
                                />
                            </FeatureCard>
                        </Stack>
                    </Box>
                </Fade> :
                <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    height={items === 0 ? '100%' : 0}
                    className={"Loading"}
                    sx={{userSelect: 'none', overflow: 'hidden', position: "absolute", top: 0, width: "100%"}}
                >
                    <div style={{position: "relative"}}>
                        <img src={Planet} id={'logo-spin'}
                             alt={'logo'} style={{
                            animation: "App-logo-spin ease-in 3s, App-logo-spin 2s linear 3s infinite",
                            animationPlayState: (loading ? 'running' : 'paused'), position: "absolute"
                        }}/>
                        <img src={Boxs} id={'logo-spin'}
                             alt={'logo'} style={{
                            animation: "glow ease-in-out infinite 3s",
                            animationPlayState: (loading ? 'running' : 'paused'), position: "relative"
                        }}/>
                    </div>
                </Box>
    )
}

export default NoItems;